'use client'
import { Loader2, Trash2 } from 'lucide-react'
import { removeCartItemsAction } from './remove-button.actions'
import { useSetCart, withCartStoreSuspense } from '@/stores/cart-store'
import RemoveItemAlert from './remove-item-alert'
import { useState } from 'react'
import { EligibilitySectionData } from '@/lib/api/strapi/eligibility-section/eligibility-section.types'
import useSafeAction from '@/lib/safe-action/use-safe-action'

interface RemoveButtonProps {
  id: string
  showAlert?: boolean
  eligibilitySection?: EligibilitySectionData['attributes']
}

const RemoveButton = ({
  id,
  showAlert,
  eligibilitySection,
}: RemoveButtonProps) => {
  const [open, setOpen] = useState(false)
  const setCart = useSetCart()
  const { execute, isExecuting } = useSafeAction(removeCartItemsAction, {
    onSuccess: ({ data }) => {
      data && setCart(data)
      setOpen(false)
    },
    onSettled: async () => {
      setOpen(false)
    },
  })

  const removeItem = async () => {
    execute([id])
  }

  const handleClick = async () => {
    if (showAlert) {
      setOpen(true)
      return
    }

    removeItem()
  }
  return (
    <>
      <button
        onClick={handleClick}
        className="flex items-center justify-center rounded-full border border-black p-1 disabled:opacity-60"
        disabled={isExecuting}
        aria-busy={isExecuting}
      >
        {isExecuting ? (
          <Loader2 className="size-4 animate-spin" strokeWidth={1.5} />
        ) : (
          <Trash2 className="size-4" />
        )}
      </button>

      <RemoveItemAlert
        open={open}
        isExecuting={isExecuting}
        onOpenChange={(open) => {
          if (!isExecuting) {
            setOpen(open)
          }
        }}
        onConfirm={removeItem}
        onCancel={() => {
          if (!isExecuting) {
            setOpen(false)
          }
        }}
        title={eligibilitySection?.remove_modal.title}
        description={eligibilitySection?.remove_modal.info_message}
        affirmative_button_text={
          eligibilitySection?.remove_modal.affirmative_button_text
        }
        negative_button_text={
          eligibilitySection?.remove_modal.negative_button_text
        }
      />
    </>
  )
}

export default withCartStoreSuspense(RemoveButton)
